<script setup lang="ts">
    import { ALERT_STATUS } from '~/app/common/enums/AlertStatus';
    import { InvoiceNotifyFormCreditsInterface } from '~/app/invoicing/endpoints/types';

    const { t } = useTranslation();
    const props = defineProps<{
        credits: InvoiceNotifyFormCreditsInterface | null;
        noStyle?: boolean;
    }>();

    const HasNoCredits = computed(() => props.credits?.available === 0);
    const hasAutomatedPurchase = computed(() => props.credits?.automatedPurchase ?? false);
    const hasEnoughCredits = computed(() => props.credits?.enough === true);
    const status = computed(() => {
        if (hasAutomatedPurchase.value && HasNoCredits.value) {
            return ALERT_STATUS.AUTOMATED;
        }
        if (hasEnoughCredits.value) {
            return ALERT_STATUS.SUCCESS;
        }
        if (!hasEnoughCredits.value) {
            return ALERT_STATUS.WARNING;
        }

        return ALERT_STATUS.ERROR;
    });

    const icon = computed(() => {
        if (props.noStyle) {
            return 'fa-regular fa-credit-card';
        }
        switch (status.value) {
            case ALERT_STATUS.SUCCESS:
            case ALERT_STATUS.AUTOMATED:
                return 'fa-check-circle';
            case ALERT_STATUS.WARNING:
                return 'fa-exclamation-circle';
            case ALERT_STATUS.ERROR:
                return 'fa-xmark-circle';
        }
    });

    const text = computed(() => {
        switch (status.value) {
            case ALERT_STATUS.SUCCESS:
                return t('invoicing.invoice_notify_credits_alert.success', { available: props.credits!.available, cost: props.credits!.cost });
            case ALERT_STATUS.WARNING:
                return t('invoicing.invoice_notify_credits_alert.warning', { available: props.credits!.available, cost: props.credits!.cost });
            case ALERT_STATUS.ERROR:
                return t('invoicing.invoice_notify_credits_alert.error', { available: props.credits!.available, cost: props.credits!.cost });
            case ALERT_STATUS.AUTOMATED:
                return t('invoicing.invoice_notify_credits_alert.automated');
        }
    });
</script>

<template>
    <div>
        <div
            v-if="credits"
            class="flex items-center gap-2 p-4 text-white rounded"
            :class="noStyle ? '!text-black !p-0' : useStatusAccentBackgroundColour(status)"
        >
            <div>
                <i
                    class="fa-regular"
                    :class="noStyle ? 'text-lg ' + icon : 'text-xl ' + icon"
                />
            </div>
            <div>
                <p class="text-sm">
                    {{ text }}
                </p>
            </div>
        </div>
    </div>
</template>
